module.exports = __webpack_public_path__ + "img/xl_sc.61eb2a5e.png";